import { Component, Input, OnInit } from '@angular/core';
import { Company, InfoCompany } from 'src/app/shared/Interfaces/company';
import { Order } from 'src/app/shared/Interfaces/order';
import { ConnectionService } from 'src/app/shared/services/Connection/connection.service';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.css']
})
export class ProgressBarComponent implements OnInit {
  @Input() order!: Order;
  vibration = false;
  company!: Company;

  constructor(private connection: ConnectionService){
    this.connection.company$.subscribe((data) =>{
      this.company = data;
    })
  }



  ngOnInit(): void {
      setInterval(() => {
        this.startVibration();
        setTimeout(() => this.stopVibration(), 400);
      }, 2000);
  }

  startVibration() {
    this.vibration = true;
  }

  stopVibration() {
    this.vibration = false;
  }
}
